import script from "./AListaDeItens.vue?vue&type=script&setup=true&lang=ts"
export * from "./AListaDeItens.vue?vue&type=script&setup=true&lang=ts"

import "./AListaDeItens.vue?vue&type=style&index=0&id=716a5720&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-716a5720"]])

export default __exports__